import {
    APP_LOAD,
    CONNECTED_ACCOUNT_LOAD_FINISHED,
    CONNECTED_PRODUCTS_LOAD_FINISHED,
    CREATE_EVENT_AUDIT, DELETE_DRAFT_EVENT,
    LOAD_CURRENCIES,
    REMOVE_EVENT_FROM_QUEUE,
    SCHEDULE_CREATE_EVENT,
    SET_COMPANY_DATA,
    SET_COMPANY_STATS,
    SET_CONTROL_BAR,
    SHOW_PWA_PROMPT,
    SPINNER_VISIBLE, UPDATE_DRAFT_EVENT, UPLOAD_CANCEL,
    UPLOAD_PROGRESS,
    UPLOAD_REMOVE,
    UPLOAD_VIDEO_FINISHED
} from '../constants/actionTypes';
import { CONVERT_STATUS, UPLOADING_STATUS } from '../constants';

const defaultState = {
    appName: 'Fantisy',
    spinner: false,
    company: null,
    upload: [],
    connected_account: null,
    connected_products: [],
    pwaPromptFlag: false,
    controlBar: null,
    createEventQueue: [],
    createdEventsQueue: [],
    draftEvent: {},
    currency: { rate: 1, alignment: '' }
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case APP_LOAD:
            return {
                ...state,
                appLoaded: true
            };
        case SPINNER_VISIBLE:
            return {
                ...state,
                spinner: action.payload
            };
        case SET_COMPANY_DATA:
            return {
                ...state,
                company: action.payload
            };
        case SET_COMPANY_STATS:
            return {
                ...state,
                company: { ...state.company, ...{ streamingStats: { ...action.payload } } }
            };
        case CONNECTED_ACCOUNT_LOAD_FINISHED:
            return {
                ...state,
                connected_account: action.payload
            };
        case CONNECTED_PRODUCTS_LOAD_FINISHED:
            return {
                ...state,
                connected_products: action.payload
            };
        case UPLOAD_PROGRESS:
        case UPLOAD_VIDEO_FINISHED: {
            const { url, progress, trailer, show, jobId, reference, ...rest } = action.payload;
            let _upload = state.upload;
            if (_upload.find((x) => x.jobId == jobId)) {
                _upload = _upload.map((x) => {
                    if (x.jobId == jobId) {
                        if (trailer) {
                            return {
                                ...x,
                                trailer_url: url,
                                trailer_progress: progress,
                                trailer_show: show,
                                trailer_reference: reference,
                                ...rest
                            };
                        }
                        return {
                            ...x,
                            upload_url: url,
                            upload_progress: progress,
                            upload_show: show,
                            upload_reference: reference,
                            ...rest
                        };
                    }
                    return x;
                });
            } else {
                _upload = [..._upload, {jobId}];
            }

            return {
                ...state,
                upload: _upload,
                createEventQueue: state.createEventQueue.map((el) => {
                    let updateEl = {};
                    if (el.correlation_id === jobId) {
                        if (el.hasTrailer) {
                            // If it's a trailer update
                            if (trailer) {
                                updateEl.trailer = url;
                            } else {
                                updateEl.endpoint = url;
                            }
                            // Update processingStatus to CONVERT_STATUS only if both trailer and video are finished
                            if (
                                (updateEl.trailer && el.endpoint) ||
                                (el.trailer && updateEl.endpoint)
                            ) {
                                updateEl.processingStatus = CONVERT_STATUS;
                            }
                        } else {
                            // If it's a video upload without trailer
                            if (trailer) {
                                updateEl.trailer = url;
                            } else {
                                updateEl.processingStatus = CONVERT_STATUS;
                                updateEl.endpoint = url;
                            }
                        }
                    }

                    return el.correlation_id === jobId ? { ...el, ...updateEl } : el;
                })
            };
        }
        case SCHEDULE_CREATE_EVENT: {
            const { payload } = action;
            return {
                ...state,
                createEventQueue: state.createEventQueue
                    .map((el) => {
                        const newEl =
                            el.correlation_id === payload.event.correlation_id
                                ? { ...el, ...payload.event, hasTrailer: payload.hasTrailer }
                                : el;
                        return newEl;
                    })
                    .concat(
                        state.createEventQueue.some(
                            (el) => el.correlation_id === payload.event.correlation_id
                        )
                            ? []
                            : [{ ...payload.event, hasTrailer: payload.hasTrailer }]
                    )
            };
        }
        case REMOVE_EVENT_FROM_QUEUE: {
            return {
                ...state,
                createEventQueue: state.createEventQueue.filter(
                    (event) => event.correlation_id !== action.payload.correlation_id
                )
            };
        }
        case CREATE_EVENT_AUDIT: {
            const { payload } = action;
            return {
                ...state,
                createdEventsQueue: state.createdEventsQueue.concat(
                    state.createEventQueue.some(
                        (el) => el.correlation_id === payload.correlation_id
                    )
                        ? []
                        : [{ ...payload }]
                )
            };
        }
        case UPLOAD_REMOVE: {
            return {
                ...state,
                upload: [
                    ...state.upload.filter((e) => {
                        action.payload.some((u) => e.jobId !== u.correlation_id);
                    })
                ]
            };
        }
        case UPLOAD_CANCEL: {
            const { payload } = action;
            return {
                ...state,
                upload: state.upload
                    .map((el) => {
                            if (el.jobId === payload.jobId ) {
                                if (payload.trailer) {
                                    const {trailer_url, trailer_progress, trailer_show , trailer_reference, ...rest} = el;
                                    return { ...rest};
                                } else {
                                    const {upload_url, upload_progress, upload_show , upload_reference , ...rest} = el;
                                    return { ...rest};
                                }
                            } else {
                               return el;
                            }
                    })
            };
        }
        case SHOW_PWA_PROMPT:
            return {
                ...state,
                pwaPromptFlag: action.payload
            };
        case SET_CONTROL_BAR:
            return {
                ...state,
                controlBar: action.payload
            };
        case LOAD_CURRENCIES:
            return {
                ...state,
                currency: action.payload
            };

        case UPDATE_DRAFT_EVENT: {
            const { payload } = action;
            const draftEvent = state.draftEvent;
            return {
                ...state,
                draftEvent: { ...draftEvent , ...payload }
            };
        }
        case DELETE_DRAFT_EVENT:
            return {
                ...state,
                draftEvent: {}
            };
        default:
            return state;
    }
};
